import CreateApiKeyForm from './CreateApiKeyForm'

export default CreateApiKeyForm
